import React from 'react';
import { Box, Stack, Heading, Body } from '@hover/blueprint';
import { IHomePageCaseStudy } from '../../../interfaces/IHomePageCaseStudy';
import QuotationMarkIcon from '../../../assets/svgs/QuotationMarkIcon';

interface Props {
  caseStudy: IHomePageCaseStudy;
}

const CaseStudy: React.FC<Props> = ({ caseStudy }) => (
  <Stack
    pt={{ base: 700, tablet: 1000 }}
    pb={{ base: '82px', tablet: '193px' }}
    spacing={{ base: 500, desktop: 'auto' }}
    direction={{ base: 'column', tablet: 'row' }}
    alignItems={{ base: 'flex-start', tablet: 'center' }}
  >
    <Box
      mb={{ base: 800, tablet: 0 }}
      maxW={{ base: '320px', tablet: '280px', desktop: '380px' }}
      alignSelf="center"
    >
      {caseStudy.image}
    </Box>
    <Box>
      <Box d={{ base: 'flex', tablet: 'none' }}>
        <QuotationMarkIcon style={{ minWidth: 24, minHeight: 24, width: 24 }} />
      </Box>
      <Box d={{ base: 'none', tablet: 'flex' }}>
        <QuotationMarkIcon style={{ minWidth: 32, minHeight: 32 }} />
      </Box>
      <Box mt={{ base: 0, tablet: 300 }} maxW="640px" flexDir="column" ml={300}>
        <Heading
          marginBottom={{ base: 500, tablet: 500 }}
          size={{ base: 200, tablet: 500 }}
          isDisplay
        >
          {caseStudy.description}
        </Heading>
        <Body
          maxW="90%"
          mb={100}
          size={{ base: 300, desktop: 500 }}
          isBold
          letterSpacing="1px"
        >
          {caseStudy.name.toUpperCase()}
        </Body>
        <Body maxW="90%" size={{ base: 300, desktop: 500 }} letterSpacing="1px">
          {caseStudy.role.toUpperCase()}
        </Body>
      </Box>
    </Box>
  </Stack>
);

export default CaseStudy;
